(function() {
/* - - - - - - - - - - - - - - - - - - - - */

	//DEBUG
	Q = require("x_x-d");
	Q.mode(1);
	O = require("x_x-i");
	O.mode(0, "rgba(55,55,55,0.5)", "normal", 0);

	//jQuery
	//jQuery = require('jquery');

	//Underscore.js
	//_ = require('underscore');
	
	//CreateJS
	if (typeof window === 'undefined') {
		this.createjs = this.createjs || {};
	} else {
	  window.createjs = window.createjs || {};
	}
	require("./../../../../bower_components/EaselJS/lib/easeljs-0.8.2.combined.js");
	require("./../../../../bower_components/PreloadJS/lib/preloadjs-0.6.2.combined.js");
	require("./../../../../bower_components/TweenJS/lib/tweenjs-0.6.2.combined.js");
	
	//easeljs webgl
	//require("easelWebGL");
    require("transit");
    require("CSSPlugin");
	createjs.CSSPlugin.install();
	
/* - - - - - - - - - - - - - - - - - - - - */

	window.C=require('./cjs.canvas.js');
	C.set();
	
})();
